import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Content} from 'antd/es/layout/layout';
import useUserData from '../../../base/hooks/useUserData';
import Dashboard from '../dashboard/dashboard';
import { NavigateChildrenCallback } from '../../../common/CallBack';
import './indexPage.scss';
import DeleteAlert from '../../commonViews/deleteModel/deleteModel';
import Header from '../compentent/header/header';
// 手机适配
import '../../phone/appointmentManagement/indexPage/indexPage.scss';
interface NavItem {
  key: string;
  title: string;
  icon: string;
  isExpanded: boolean;
  path: string;
  list: NavItem[];  // list 是 NavItem 类型的数组
  activeIcon: string;
  isShow: boolean;
  isShowChild: boolean;
}

const HomePage = React.memo(() => {
  const { userData, loginStatus } = useUserData();
  useEffect(() => {
    if(localStorage.getItem('token')){
      if(userData){
        if(userData?.is_user && userData?.is_user > 1){
          navigate('/appointmentManagement/dashboard');
        }else{
          navigate('/');
        }
      }
    }else{
      navigate('/');
    }
  }, [loginStatus]);
  const navList: NavItem[] = [
    {
      key: 'dashboard',
      title: 'Dashboard',
      icon:'',
      activeIcon:'',
      list: [],
      isExpanded: false,
      path: '/appointmentManagement/dashboard',
      isShow: true,
      isShowChild: false,
    }
  ]
  // 用来存储哪个项的子菜单是否展开
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedKey, setSelectedKey] = useState("dashboard");
  const [childrenKeys, setChildrenKeys] = useState<string[]>([]);
  const [openLogoutAlert, setOpenLogoutAlert] = useState(false);
  const [pathName, setPathName] = useState<string>('');
  const [unreadCount,setUnreadCount] = useState(0);
  const [ updateInfo, setUpdateInfo ] = useState<null | Record<string, any>>(null);
  const [isShowNav, setIsShowNav] = useState(false);
  const [isMobileType, setIsMobileType] = useState(false);
  useEffect(() => {
    const userAgent = navigator.userAgent;
    const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(userAgent);
    if(isMobile){
      setIsMobileType(true);
    }else{
      setIsMobileType(false);
    }
  }, []);
  useEffect(() => {
    if(isShowNav){
        document.body.style.overflow = 'hidden';
    }else{
        document.body.style.overflow = 'auto';
    }
}, [isShowNav]);
  // 乱输入路由回到首页
  useEffect(() => {
    const path = location.pathname;
    setPathName(path);
    const pathSegments = path.split('/').filter(segment => segment);
    if(pathSegments.length > 2){
      const groups = pathSegments[1]; // 获取 /dashboard/xxxxx 中的 xxxxx
      const items = pathSegments[2];
      // 获取当前的导航列表
      const groupList = navList.find(temp => groups === temp.key);
      if(groupList && groupList.list.length > 0){
        const item = groupList.list.find(temp => items === temp.key);
        if(item){
          setSelectedKey(groups);
          setChildrenKeys(pathSegments.slice(2));
        }else{
          setSelectedKey(items);
          navigate(groupList.list[0].path)
        }
      }
    }
  }, [location.pathname, navigate]);
  const handleNavigateChildren = (path: string, data: any) => {
    if (path === "") {
      navigate(selectedKey);
    } else {
      navigate(`${selectedKey}/${path}`, {
        state: { data }
      });
    }
  };

  const getUpdateInfo = (info: null | Record<string, any>) => {
    setUpdateInfo(info);
  }
  const navChild = (item: any) => {
    return (
      <>
      {
          item.list.length > 0 && item.isExpanded && (
            <div className="sub-item-list">
              {item.list.map((items: any) => (
                <>
                <div
                  style={{ display: items.isShow ? 'block' : 'none' }}
                  key={items.key} 
                  className={`sub-item-list-item ${childrenKeys[childrenKeys.length - 1] === items.key ? 'sub-item-list-item-active' : ''}`} onClick={() => {
                    navigate(items.path);
                    console.log(childrenKeys,items.key,2222)
                    if(items.isShowChild){
                      items.isExpanded = !items.isExpanded;
                    }
                  }}>{items.title}</div>
                  {navChild(items)}
                </>
              ))}
            </div>
          )
        }
      </>
    )
  }
  return (
    <div className="user-tatio-main">
      <div className="right">
        <Header 
            childrenKeys={childrenKeys}
            selectedKey={selectedKey} 
            pathName={pathName} 
            unreadCount={unreadCount} 
            updateInfo={updateInfo} 
            userData={userData} 
            isShowNavEvent={() => {
              setIsShowNav(true);
            }}
            openLogoutAlertevent={() => {
              setOpenLogoutAlert(true);
            }}/>
          <div className="right-back"></div>
          <div className="all-content">
            <Content className='content'>
              <ContentRenderer 
              selectedKey={selectedKey} 
              childrenKeys={childrenKeys} 
              onNavigateChildren={handleNavigateChildren} 
              setOpenLogoutAlert={setOpenLogoutAlert}  
              getUpdateInfo={getUpdateInfo} />
            </Content>
          </div>
        </div>
      {/* 退出登录 */}
      <DeleteAlert isModalOpen={openLogoutAlert} handleCancel={() => {
          setOpenLogoutAlert(false);
      }} handleOk={() => {
          setOpenLogoutAlert(false);
          localStorage.removeItem("token");
          navigate("/");
      }} title="Log Out" content="Are you sure you want to log out of your account?" btnContent={['Cancel', 'Confirm']}/>
    </div>

  );
});

const ContentRenderer = ({ selectedKey, 
  childrenKeys, 
  onNavigateChildren,
   setOpenLogoutAlert, 
   getUpdateInfo }: { selectedKey: string, childrenKeys: string[], onNavigateChildren: NavigateChildrenCallback, setOpenLogoutAlert: (value: boolean) => void, getUpdateInfo: (info: null | Record<string, any>) => void }) => {
  switch (selectedKey) {
    case "dashboard":
        return <Dashboard/>;
    default:
      return <div>404</div>;
  }
};

export default HomePage;
